import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme, Box } from '@mui/material'
import { Select } from '@center/ui-kit'
import { components } from 'react-select'
import useFilters from '../store'
import { PROVIDER_OPTIONS } from '../utils/constants'
import ContentFilters from './FiltersStyles'
import {
  DropdownIndicator,
  ValueContainer,
  CustomOption,
  CustomControl,
  getSelectStyles
} from 'components/global/Selects/SingleSelectStyles'
import { trackEvent } from 'analytics'

interface ProviderSelectChoice {
  label: string
  value: string
  id: number
}

const Filters: React.FC = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [filters, setFilters] = useFilters()

  const choices: ProviderSelectChoice[] = PROVIDER_OPTIONS.map((option, index) => ({
    label: option.label,
    value: option.value,
    id: index,
  }))

  const setProvider = (provider: string) => {
    setFilters(prev => ({ ...prev, provider }))
    trackEvent('wan_filter_changed', {
      filter_name: 'provider',
      filter_value: provider || 'all',
    })
  }

  return (
    <ContentFilters>
      <Select
        value={filters.provider ? choices.find((choice) => choice.value === filters.provider) : null}
        onChange={(value) => setProvider(value ? value.value : '')}
        options={choices}
        mainField={'label'}
        placeholder={t('wan.filters.provider_placeholder')}
        components={{
          Option: CustomOption,
          DropdownIndicator,
          ValueContainer,
          Control: CustomControl,
          IndicatorSeparator: () => null,
          ClearIndicator: () => null,
          MenuList: (props) => {
            return (
              <components.MenuList {...props}>
                {props.children}
                <Box
                  ml={1}
                  mt={1}
                  color={'grey.600'}
                  fontSize={12}
                  fontWeight={500}
                  onClick={() => setProvider('')}
                  sx={{
                    cursor: 'pointer',
                    '&:hover': {
                      color: theme.palette.grey[800],
                    },
                  }}
                >
                  {t('actions.deselect_all')}
                </Box>
              </components.MenuList>
            );
          },
        }}
        menuPortalTarget={document.body}
        styles={getSelectStyles(theme)}
      />
    </ContentFilters>
  )
}

export default Filters
